import React, { useEffect, useState } from 'react';
import BadgesComponent from '@components/common/Badges';
import ToggleComponent from '@components/common/Toggle';
import CheckboxComponent from '@components/common/CheckBox';
import DataTable from '@components/common/CommonDataTable';
import InputFields from '@components/common/InputFields';
import SearchableDropdownComponent from '@components/common/SearchableDropDown';
import './overview.css';
import EditIcon from '@assets/svg_main/edit_outline.svg';

import { stateList, districtList, blockList, villageList, wardList, ulbList } from '@constants/index';
import { useSelector } from 'react-redux';
import RadioButtonComponent from '@components/common/Radios';

import endpoints from '@config/endpoints';
import AntDateFieldsComponent from '@components/common/AntDatePickerFields';
import dayjs from 'dayjs';

const stateOption = stateList?.map(state => ({ value: `${state.stateNameEnglish} - ${state.stateCode}`, label: `${state.stateNameEnglish} - ${state.stateCode}` }));
const districtOption = districtList?.map(district => ({ value: `${district.districtNameEnglish} - ${district.districtCode}`, label: `${district.districtNameEnglish} - ${district.districtCode}` }));
const blockOption = blockList?.map(block => ({ value: `${block.blockNameEnglish} - ${block.blockCode}`, label: `${block.blockNameEnglish} - ${block.blockCode}` }));
const villageOption = villageList?.map(village => ({ value: `${village.villageNameEnglish} - ${village.villageCode}`, label: `${village.villageNameEnglish} - ${village.villageCode}` }));
const wardOption = wardList?.map(ward => ({ value: `${ward.wardNameEnglish} - ${ward.wardCode}`, label: `${ward.wardNameEnglish} - ${ward.wardCode}` }));
const ulbOption = ulbList?.map(ulb => ({ value: `${ulb.localBodyNameLocal} - ${ulb.localBodyCode}`, label: `${ulb.localBodyNameLocal} - ${ulb.localBodyCode}` }));
const STATE_ID: string = '42629363-b71b-4d32-86fa-167ecfe440e7';
const DISTRICT_ID: string = '8a7d660c-8894-4680-b14c-e28132d2c15a';

interface objectType {
    user: any;
    flow: string;
    handleChange: (e: any, key: string) => void;
    setUpgrade: (args: boolean) => void;
    isSimilar:any

}

// const style = {
//   control : (baseStyle: any) => ({
//     ...baseStyle,
//     height: '30px'
//   }),
//   valueContainer: (baseStyle: any) => ({
//     ...baseStyle,
//     height: '30px',
//     // display: 'block',
//     // marginTop: '6px'
//   }),
// }
const isClickedStyle: any = {
    background: 'lightgrey',
    color: '#af2d94'
}
export const useUpperComponent = () => {
    const [state, setState] = useState('correction');
    const component = <div className="upper-component">
        <span style={{ margin: "0.5rem" }}>
            <RadioButtonComponent
                onRadioButtonChange={() => setState('correction')}
                radioName={'Correction'}
                radioValue={state}
                radioButtonGroup={'Group'}
                defaultChecked={true}
            />
        </span>
        <span style={{ margin: "0.5rem" }}>
            <RadioButtonComponent
                onRadioButtonChange={() => setState('upgrade')}
                radioName={'Upgrade'}
                radioButtonGroup={'Group'}
            />
        </span>
    </div>;

    return [component, state];
};


const HealthManagementOverview = (props: objectType) => {
    const { user, flow, handleChange, setUpgrade } = props;
    const { name, district, type_name, villages, wards, village, ward } = user;
    const healthBlockById: any = useSelector((state: any) => state?.GeoNonGeoData?.healthBlockById);
    const districtsByStateId: any = useSelector((state: any) => state?.GeoNonGeoData?.districtByState);
    const villageByBlockId: any = useSelector((state: any) => state?.GeoNonGeoData?.villageByBlockId);
    const wardByULBId: any = useSelector((state: any) => state?.GeoNonGeoData?.wardByULBId);
    const ulbByHealthBlockId: any = useSelector((state: any) => state?.healthBlock?.ulbByHealthBlockId);
    const ULB_ID = ulbByHealthBlockId[user.id]?.[0]?.ulb_id;
    const subDistrictByHealthBlockId: any = useSelector((state: any) => state?.healthBlock?.subDistrictByHealthBlockId);
    const blockByHealthBlockId: any = useSelector((state: any) => state?.healthBlock?.blockByHealthBlockId);
    const BLOCK_ID = blockByHealthBlockId[user?.id]?.[0]?.block_id;
    const villageByHealthBlockId: any = useSelector((state: any) => state?.healthBlock?.villageByHealthBlockId);
    const wardByHealthBlockId: any = useSelector((state: any) => state?.healthBlock?.wardByHealthBlockId);
    const subDistrictByDistrict: any = useSelector((state: any) => state?.healthBlock?.subDistrictByDistrict);
    const blockByDistrict: any = useSelector((state: any) => state?.healthBlock?.blockByDistrict);
    const ulbByState: any = useSelector((state: any) => state?.healthBlock?.ulbByState);
  
    
    const districtsInformation = districtsByStateId[STATE_ID];

    const villagesList = villageByBlockId[BLOCK_ID]?.map((village: any) => ({
        label: `${village.village_name} -${village.village_code}`,
        value: `${village.village_name} -${village.village_code}`
    }))
    const wardsList = wardByULBId[ULB_ID]?.map((ward: any) => ({
        label: `${ward.ward_name} -${ward.ward_code}`,
        value: `${ward.ward_name} -${ward.ward_code}`
    }))


    const [Component, state] = useUpperComponent();
    useEffect(() => {
        if (state === "upgrade") {
            setUpgrade(true);
        }
        else {
            setUpgrade(false);
        }
    }, [state]);
    return (
        <>
            <div className="non-geo-upgrade">
                <div className="overview-healthblock">
                    {!(flow === "view") && Component}
                    <BadgesComponent
                        className="over-badge"
                        badgeName={type_name==="Sub Division"?"Sub Division Details":"Health Block Details"}
                        variant="primary-1"
                        badgeType="case5"
                    />
                    <div className="overview-healthblock-details">
                        <div className="overview-details-value-type">
                            {flow === "view" ? <label className="overview-details-label">Type</label>:"" }
                            {<div>{
                                flow == "view" ? type_name :
                                    (
                                        <SearchableDropdownComponent
                                            options={blockOption}
                                            onChange={(option: any) => { handleChange(option.value, 'block') }}
                                            placeHolder="Health Block"
                                            multipleSelection={false}
                                            dropDownType="entered"
                                            dropLabelName="Type"
                                            ifRequired={true}
                                            dropDownDisable={true}
                                            dropdownsearchable={false}
                                            isClearable={false}
                                            value={{ value: type_name, label: type_name }}
                                        />
                                    )
                            }</div>}
                        </div>
                        <div className="overview-details-value-efd">
                        {flow==="view"?<label className="overview-details-label">Effective From Date</label>:""}
                            <div>{
                                flow === 'view' ? dayjs(healthBlockById[user.id][0]?.effective_from_dt)?.format('DD-MM-YYYY') :
                                    <AntDateFieldsComponent
                                        placeholder={'Enter date'}
                                        className={'overview-edit-email'}
                                        onChange={(changedData) => handleChange(changedData, 'effective_from_dt')}
                                        labelName="Effective From Date"
                                        isDisabled={state === 'upgrade' ? false : true}
                                        type="date"
                                        required={true}
                                        value={healthBlockById[user?.id][0]?.effective_from_dt ? dayjs(healthBlockById[user?.id][0]?.effective_from_dt) : undefined}
                                    />
                            }</div>
                        </div>
                    </div>
                </div>
                <div className="overview-healthblock">
                    <BadgesComponent
                        className="over-badge"
                        badgeName="Location details"
                        variant="primary-1"
                        badgeType="case5"
                    />
                    <div className="overview-location-details">
                        <div className="overview-details-value-dist">
                            {flow ==='view'?
                        <label className="overview-details-label">District</label>:""}
                            <div >{
                                flow === 'view' ? healthBlockById[user.id][0]?.district_name :
                                    <SearchableDropdownComponent
                                        options={districtOption}
                                        onChange={(option: any) => { handleChange(option.value, 'district') }}
                                        placeHolder="Select District"
                                        multipleSelection={false}
                                        dropDownType="entered"
                                        dropLabelName="District"
                                        ifRequired={true}
                                        dropDownDisable={true}
                                        dropdownsearchable={false}
                                        isClearable={false}
                                        value={[{ label: healthBlockById[user.id][0]?.district_name, value: healthBlockById[user.id][0]?.district_name }]}
                                    />
                            }</div>
                        </div>
                        <div className="overview-details-value-hb">
                       { flow==="view"? <label className="overview-details-label">{type_name==="Sub Division"?"Sub Division Name":"Health Block Name"}</label>:""}
                            <div>{
                                flow === 'view' ? user.name :
                                    <InputFields
                                        placeholder={'Enter health block name'}
                                        className={'overview-edit-email'}
                                        onChange={(changedData) => handleChange(changedData, 'name')}
                                        inputType={user.name==='' || props.isSimilar?'error':'general'}
                                        labelName={type_name==="Sub Division"?"Sub Division Name":"Health Block Name"}
                                        errorMessage={props.isSimilar?'The name already exists. Choose a unique name to continue':(user.name===''?'Health Block name is mandatory':'')}
                                        isDisabled={false}
                                        type="text"
                                        required={true}
                                        value={user.name}
                                    />
                            }</div>
                        </div>
                        <div className="overview-details-value-subdist">
                            {flow === 'view' ? <label className="overview-details-label">Sub District</label> : ''}
                            <div>{
                                flow === 'view' ? subDistrictByHealthBlockId[user.id]?.map((subDistrict: any) => subDistrict.sub_dist_name).join(' , ') :
                                    <SearchableDropdownComponent
                                        options={subDistrictByDistrict[DISTRICT_ID]?.map((subDistrict: any) => ({
                                            label: `${subDistrict.sub_district_name}-${subDistrict.sub_district_code}`,
                                            value: `${subDistrict.sub_district_name}-${subDistrict.sub_district_code}`,
                                            ...subDistrict
                                        }))}
                                        onChange={(option: any) => { handleChange(option, 'sub_district') }}
                                        placeHolder="Select Health Block"
                                        multipleSelection={true}
                                        dropLabelName="Sub District"
                                        errorMessage={'Sub District is mandatory'}
                                        dropDownType={user.sub_district?user.sub_district?.length===0?'error':'general':
                                        subDistrictByHealthBlockId[user.id]?.length===0?'error':'general'
                                        }
                                        ifRequired={true}
                                        dropDownDisable={false}
                                        dropdownsearchable={false}
                                        isClearable={false}
                                        value={
                                            user.sub_district ? user.sub_district?.map((subDistrict:any)=>({
                                                label: subDistrict, value: subDistrict
                                            })) :
                                            subDistrictByHealthBlockId[user.id]?.map((subDistrict: any) => ({
                                                label: `${subDistrict.sub_dist_name}-${subDistrict.sub_dist_code}`, value: `${subDistrict.sub_dist_name}-${subDistrict.sub_dist_code}`
                                            }))
                                        }
                                    />
                            }</div>
                        </div>
                        <div className="overview-details-value-block">
                        {flow==="view"?<label className="overview-details-label">Block</label>:""}
                            <div>{
                                flow === 'view' ? blockByHealthBlockId[user.id]?.map((block: any) => block.block_name).join(' , ') :
                                    <SearchableDropdownComponent
                                        options={blockByDistrict[DISTRICT_ID]?.map((block: any) => ({
                                            label: `${block.block_name}-${block.block_code}`,
                                            value: `${block.block_name}-${block.block_code}`,
                                            id: block.block_id
                                        }))}
                                        onChange={(option: any) => { handleChange(option, 'block') }}
                                        placeHolder="Select Block"
                                        multipleSelection={true}
                                        dropDownType={user.block?user.block?.length===0?'error':'general':
                                        blockByHealthBlockId[user.id]?.length===0?'error':'general'
                                        }
                                        dropLabelName="Block"
                                        errorMessage={"Block name is mandatory"}
                                        ifRequired={true}
                                        dropDownDisable={false}
                                        dropdownsearchable={false}
                                        isClearable={false}
                                        value={
                                            user.block?user.block?.map((block:any)=>({
                                                label: block, value: block
                                            })):
                                            blockByHealthBlockId[user.id]?.map((block: any) => ({
                                                label: `${block.block_name}-${block.block_code}`, value: `${block.block_name}-${block.block_code}`
                                            }))
                                        }
                                    />
                            }</div>
                        </div>
                        <div className="overview-details-value-ulb">
                        {flow==="view"?<label className="overview-details-label">ULB</label>:""}
                            <div>{
                                flow === 'view' ? ulbByHealthBlockId[user.id]?.map((ulb: any) => ulb.ulb_name).join(' ') :
                                    <SearchableDropdownComponent
                                        options={ulbByState[STATE_ID]?.map((ulb: any) => ({
                                            label: `${ulb.ulb_name}-${ulb.ulb_code}`,
                                            value: `${ulb.ulb_name}-${ulb.ulb_code}`,
                                            id: ulb.ulb_id
                                        }))}
                                        onChange={(option: any) => { handleChange(option, 'ulb') }}
                                        placeHolder="Select ulb"
                                        multipleSelection={true}
                                        dropDownType={user.ulb?user.ulb?.length===0?'error':'general':
                                        ulbByHealthBlockId[user.id]?.length===0?'error':'general'
                                        }
                                        dropLabelName="ULB"
                                        errorMessage={"ULB is mandatory"}
                                        ifRequired={true}
                                        dropDownDisable={false}
                                        dropdownsearchable={false}
                                        isClearable={false}
                                        value={
                                            user.ulb?user.ulb?.map((ulb:any)=>({
                                                label: ulb, value: ulb
                                            })):
                                            ulbByHealthBlockId[user.id]?.map((ulb: any) => ({
                                                label: `${ulb.ulb_name}-${ulb.ulb_code}`, value: `${ulb.ulb_name}-${ulb.ulb_code}`
                                            }))
                                        }
                                    />
                            }</div>
                        </div>
                        <div  className="overview-details-value-vlgmap">
                        {flow==="view"?<label className="overview-details-label">Villages Mapped</label>:""}
                            <div>{
                                flow === 'view' ? villageByHealthBlockId?.[user.id]?.map((village: any) => village.village_name)?.join(' , ') :
                                    <SearchableDropdownComponent
                                        options={villagesList}
                                        onChange={(option: any) => { handleChange(option, 'villages_mapped') }}
                                        placeHolder="Select Villages"
                                        multipleSelection={true}
                                        dropDownType={villagesList?(user.villages_mapped?user.villages_mapped?.length===0?'error':'general':
                                        villageByHealthBlockId?.length===0?'error':'general'):'general'
                                        }
                                        dropLabelName="Villages Mapped"
                                        errorMessage={"Villages Mapped is mandatory"}
                                        ifRequired={villagesList?true:false 
                                        }
                                        dropDownDisable={false}
                                        dropdownsearchable={false}
                                        isClearable={false}
                                        value={
                                            user.villages_mapped?user.villages_mapped?.map((villages_mapped:any)=>({
                                                label: villages_mapped, value: villages_mapped
                                            })):
                                            villageByHealthBlockId?.[user.id]?.map((village: any) => ({
                                            label: `${village.village_name}-${village.village_code}`,
                                             value: `${village.village_name}-${village.village_code}`
                                        }))}
                                    />
                            }</div>
                        </div>
                        <div className="overview-details-value-wardmap">
                        {flow==="view"?<label className="overview-details-label">Wards Mapped</label>:""}
                            <div>{
                                flow === 'view' ? wardByHealthBlockId?.[user.id]?.map((ward: any) => ward.ward_name)?.join(' , ') :
                                    <SearchableDropdownComponent
                                        options={wardsList}
                                        onChange={(option: any) => { handleChange(option, 'wards_mapped') }}
                                        placeHolder="Select Ward"
                                        multipleSelection={true}
                                        dropDownType={wardsList?(user.wardsList?user.wardsList?.length===0?'error':'general':
                                        wardByHealthBlockId?.length===0?'error':'general'):'general'
                                        }
                                        dropLabelName="Wards Mapped"
                                        errorMessage={"Wards is mandatory"}
                                        ifRequired={wardsList?true:false }
                                        dropDownDisable={false}
                                        dropdownsearchable={false}
                                        isClearable={false}
                                        value={
                                            user.wards_mapped?user.wards_mapped?.map((wards_mapped:any)=>({
                                                label: wards_mapped, value: wards_mapped
                                            })):
                                            wardByHealthBlockId?.[user.id]?.map((ward: any) => ({
                                            label: `${ward.ward_name}-${ward.ward_code}`,
                                             value: `${ward.ward_name}-${ward.ward_code}`
                                        }))}
                                    />
                            }</div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
export default HealthManagementOverview;
